import axios from 'axios';

// set base axios url
const apiService = axios.create({
    baseURL: process.env.VUE_APP_API_URL,
    withCredentials: true, // Include cookies in requests (for Laravel session)
    headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
    }
});

// Handle 401 Unauthorized responses
apiService.interceptors.response.use((response) => response, (error) => {
    if (error.response && error.response.status === 401) {
        // Session expired or invalid - redirect to login
        if (window.location.pathname !== '/login') {
            window.location.href = '/login';
        }
    }
    return Promise.reject(error);
});

// specifies a cancel token that can be used to cancel the request
apiService.CancelToken = axios.CancelToken;
apiService.isCancel = axios.isCancel;

export default apiService;
